import { render, staticRenderFns } from "./MgmCampaignForm.vue?vue&type=template&id=29950e80&"
import script from "./MgmCampaignForm.vue?vue&type=script&lang=js&"
export * from "./MgmCampaignForm.vue?vue&type=script&lang=js&"
import style0 from "./MgmCampaignForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports